import type { PaidPlanSubscriptionData } from "@functions/state/types";
import { RapidStateCreator } from "../types";

export interface SubscriptionSliceState {
    paidPlanSubscriptionById: Record<
        string,
        { loading?: boolean; error?: Error | null; data?: PaidPlanSubscriptionData }
    >;

    fetchPaidPlanSubscription: (
        workspaceId: string,
        options?: { refetch?: boolean }
    ) => Promise<void>;
}

export const createSubscriptionSlice: RapidStateCreator<SubscriptionSliceState> = (set, get) => ({
    // Initial state
    paidPlanSubscriptionById: {},

    // Actions
    fetchPaidPlanSubscription: async (workspaceId, { refetch } = {}) => {
        if (get().paidPlanSubscriptionById?.[workspaceId] && !refetch) return;

        set(
            (state) => ({
                paidPlanSubscriptionById: {
                    ...state.paidPlanSubscriptionById,
                    [workspaceId]: { loading: true, error: null }
                }
            }),
            false,
            "fetchPaidPlanSubscription:start"
        );

        try {
            const response = await fetch(`/query/subscriptions?workspaceId=${workspaceId}`);
            const data = await response.json();

            set(
                (state) => ({
                    paidPlanSubscriptionById: {
                        ...state.paidPlanSubscriptionById,
                        [workspaceId]: { loading: false, data }
                    }
                }),
                false,
                "fetchPaidPlanSubscription:success"
            );
        } catch (error) {
            set(
                (state) => ({
                    paidPlanSubscriptionById: {
                        ...state.paidPlanSubscriptionById,
                        [workspaceId]: { loading: false, error: error as Error }
                    }
                }),
                false,
                "fetchPaidPlanSubscription:error"
            );
        }
    }
});
